var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInpatientNoData = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11969_8491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 125,
    height: 124
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 0H0.5V124H124.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11969_8491)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2778 99.2166C89.9251 102.318 105.72 94.7793 106.663 76.5996C108.077 49.33 84.2574 52.2759 77.3208 45.0889C70.3837 37.9019 78.1548 48.1155 64.7952 33.2224C55.8885 23.2935 44.0204 23.2425 29.191 33.0698C17.2295 42.8051 15.9358 55.5725 25.3095 71.3715C34.6833 87.1701 46.0059 96.4519 59.2778 99.2166Z",
    fill: "#D7D7F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11969_8491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 31,
    width: 49,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8885 31.0156H44.6567L44.6289 44.8071H92.8603L92.8885 31.0156Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11969_8491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.347 31.7179C51.5277 31.7179 52.3003 35.3711 52.3003 39.0177V42.9961C52.3003 43.6266 52.7796 44.1388 53.3695 44.1388L89.7873 43.822C90.3775 43.822 90.8565 43.3102 90.8565 42.6798V38.3908C90.8565 34.4784 87.889 31.3062 84.2289 31.3062C83.9809 31.3062 45.0882 31.7179 45.347 31.7179Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3457 32.3885C45.3457 32.9849 45.8305 33.469 46.4273 33.469C84.2365 33.469 84.2434 33.4686 84.2504 33.469C86.7281 33.4732 88.7356 35.4982 88.7395 37.9979V43.1232H89.8088C90.3986 43.1232 90.8776 42.6403 90.8776 42.0451V37.9979C90.8935 34.3014 87.936 31.2922 84.272 31.2764H84.2292H83.8301C83.732 31.2822 83.6366 31.298 83.5396 31.3084H46.4258C45.8293 31.3084 45.3457 31.7921 45.3457 32.3885Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11969_8491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 30,
    width: 61,
    height: 65
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1889 30.3237H29.8535V94.9312H89.1889V30.3237Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11969_8491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2324 33.3357V31.3076H45.724C40.6783 31.3153 36.5898 35.4382 36.582 40.5257V93.4583C36.582 94.0532 37.061 94.5361 37.6509 94.5361H70.6222C75.6613 94.5202 79.7398 90.3989 79.7433 85.3179V37.9897V37.9391C79.7746 35.4603 81.7744 33.3426 84.2324 33.3391C84.2424 33.3391 84.2517 33.336 84.2614 33.3357H84.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7023 31.3079C40.6562 31.316 36.5673 35.4389 36.5596 40.5264V71.5156L59.5834 31.2793L45.7023 31.3079Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5783 53.0227V41.2068C36.5864 36.1189 40.6749 31.9964 45.7211 31.9883H84.2291M33.8418 93.0682C36.1414 93.0682 36.5574 90.6248 36.5574 89.0808C36.5574 76.4541 36.5783 67.5284 36.5783 64.3264M36.5783 52.2095V63.8119",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.228 31.2769H83.829C80.3338 31.4897 77.6054 34.4081 77.6008 37.9408V38.0416V85.2926C77.5942 88.5123 75.4375 91.323 72.3495 92.1366C72.0119 92.2242 71.6662 92.2675 71.3208 92.271V92.2721H71.2942H71.2667H31.2939C32.8986 93.6887 34.9977 94.5497 37.2973 94.5517H37.3116H48.8367H70.6182C70.853 94.5517 71.2161 94.5517 71.4518 94.5157C71.867 94.4775 72.2788 94.408 72.6841 94.3075C76.8236 93.3352 79.7551 89.616 79.7606 85.3285V37.9767V37.9265C79.7911 35.603 81.5564 33.6796 83.8498 33.4695C83.9765 33.4625 84.2191 33.4633 84.3451 33.4695L84.228 31.2769Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11969_8491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 82,
    width: 45,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3547 82.5869H27.5352V94.7381H71.3547V82.5869Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11969_8491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2362 31.2759H83.8371C80.342 31.4891 77.6147 34.4072 77.6097 37.9398V38.0406V85.2916C77.6031 88.5114 75.4465 91.3224 72.3584 92.1356C71.6573 92.3183 70.921 92.3183 70.2203 92.1356C67.1226 91.3108 64.9667 88.4805 64.9752 85.2487V83.811C64.9795 83.2157 64.5043 82.729 63.9141 82.7255H57.1389H51.6918H43.2942H34.5017H29.2466C28.6567 82.7255 28.1777 83.2087 28.1777 83.804V85.3279C28.1731 90.4173 32.2609 94.5464 37.3062 94.5507H37.3197H48.8448H70.6259C70.8612 94.5507 71.2247 94.5507 71.4599 94.5148C71.8756 94.4765 72.2877 94.4074 72.693 94.3065C76.8325 93.3346 79.7637 89.6154 79.7687 85.3279V37.9761V37.9255C79.7992 35.6024 81.565 33.6782 83.8588 33.4689C83.9916 33.4615 84.1245 33.4615 84.2578 33.4689C86.7355 33.4727 88.7431 35.4981 88.7473 37.9974V43.1231H89.8162C90.4064 43.1231 90.8854 42.6402 90.8854 42.045V37.9974C90.9009 34.3009 87.9434 31.2921 84.2794 31.2759H84.2362Z",
    fill: "#E6E6E6"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1963 73.3218H55.6474",
    stroke: "#2E2BEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1963 63.5879H55.6474",
    stroke: "#2E2BEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1953 53.854H68.8847",
    stroke: "#2E2BEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1953 43.4229H71.622",
    stroke: "#2E2BEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7705 72.2894C87.4987 71.5635 88.6768 71.5647 89.4042 72.2909L98.5934 81.465C99.3184 82.1889 99.3192 83.3636 98.5953 84.0891L98.5922 84.0921C97.864 84.8176 96.6859 84.8172 95.9581 84.0906L86.7689 74.9169C86.0439 74.1926 86.0431 73.0179 86.767 72.2928L86.7705 72.2894Z",
    fill: "#2E2BEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7355 74.1879C94.4096 68.9885 94.8028 60.1833 89.6141 54.5208C84.4251 48.858 75.6194 48.4826 69.9452 53.682C64.2711 58.8814 63.877 67.6869 69.066 73.3497C74.2547 79.0121 83.0613 79.3874 88.7355 74.1879Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7355 74.1879C94.4096 68.9885 94.8028 60.1833 89.6141 54.5208C84.4251 48.858 75.6194 48.4826 69.9452 53.682C64.2711 58.8814 63.877 67.6869 69.066 73.3497C74.2547 79.0121 83.0613 79.3874 88.7355 74.1879Z",
    stroke: "#2E2BEB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4794 67.0621L83.1614 68.3793L79.769 64.9869L76.402 68.3534L75.0767 67.0285L78.4436 63.6611L75.0508 60.2683L76.3688 58.9507L79.7612 62.3435L83.1282 58.9766L84.4535 60.3019L81.0866 63.6693L84.4794 67.0621Z",
    fill: "#2E2BEB"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInpatientNoData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/InpatientNoData.cd7c47b8.svg";
export { ForwardRef as ReactComponent };